<template>
    <div class="container mt-4" v-if="(client_segment !== 19 && client_segment !== 20) && !is_champion">
        <div class="row">
            <div class="col-12 col-md-6 mt-4">
                <h5 class="text-title-bat">Conoce tu avance</h5>
            </div>
            <div class="col-12 col-md-6 container-dropdown-pdv">
                <div class="filter-month-staff">
                    <div class="custom-select" ref="customSelect" @click="toggleDropdown" :class="{ open: isOpen }">
                        <div v-if="!isOpen" class="selected-option" @click="toggleDropdown">
                            <div class="pdv-name" @click="toggleDropdown">
                                {{ selectedPdvObj ? truncateText(selectedPdvObj.name_pdv, 35) : 'Selecciona un PDV' }}
                            </div>
                            <div class="pdv-address" v-if="selectedPdvObj" @click="toggleDropdown">
                                <img src="/img-version2/icons/staff/location.svg" alt="location">
                                {{ truncateText(selectedPdvObj.address_pdv, 35) }}
                            </div>
                        </div>
                        <div v-else class="search-box" @click.stop>
                            <input
                                type="text"
                                v-model="searchQuery"
                                placeholder=""
                                ref="searchInput"
                            />
                        </div>
                        <i class="arrow" :class="{ open: isOpen }"></i>
                    </div>

                    <div v-if="isOpen" class="options-list" ref="optionsList">
                        <div
                            v-for="pdv in filteredPdvs"
                            :key="pdv.id"
                            class="option-item"
                            @click.stop="selectPdv(pdv)"
                        >
                            <div class="pdv-name">
                                {{ truncateText(pdv.name_pdv, 35) }}
                            </div>
                            <div class="pdv-address">
                                <img src="/img-version2/icons/staff/location.svg" alt="location">
                                {{ truncateText(pdv.address_pdv, 35) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="is_champion" class="order-0 order-md-0 order-lg-1 order-xl-1 col-12 col-md-6 text-center text-md-end">
        <div class="filter-month-staff">
            <div class="custom-select" ref="customSelect" @click="toggleDropdown" :class="{ open: isOpen }">
                <div v-if="!isOpen" class="selected-option" @click="toggleDropdown">
                    <div class="pdv-name" @click="toggleDropdown">
                        {{ selectedPdvObj ? truncateText(selectedPdvObj.name_pdv, 35) : 'Selecciona un PDV' }}
                    </div>
                    <div class="pdv-address" v-if="selectedPdvObj" @click="toggleDropdown">
                        <img src="/img-version2/icons/staff/location.svg" alt="location">
                        {{ truncateText(selectedPdvObj.address_pdv, 35) }}
                    </div>
                </div>
                <div v-else class="search-box" @click.stop>
                    <input
                        type="text"
                        v-model="searchQuery"
                        placeholder=""
                        ref="searchInput"
                    />
                </div>
                <i class="arrow" :class="{ open: isOpen }"></i>
            </div>

            <div v-if="isOpen" class="options-list" ref="optionsList">
                <div
                    v-for="pdv in filteredPdvs"
                    :key="pdv.id"
                    class="option-item"
                    @click.stop="selectPdv(pdv)"
                >
                    <div class="pdv-name">
                        {{ truncateText(pdv.name_pdv, 35) }}
                    </div>
                    <div class="pdv-address">
                        <img src="/img-version2/icons/staff/location.svg" alt="location">
                        {{ truncateText(pdv.address_pdv, 35) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from './../../app';

export default {
    props: {
        client_segment: {
            default: null,
        },
        is_champion: {
            default: false,
        },
    },
    data() {
        return {
            pdvs: [],
            selectedPdv: null,
            isOpen: false,
            searchQuery: "",
        };
    },
    mounted() {
        this.getActivePdvs();
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        filteredPdvs() {
            if (!this.searchQuery) return this.pdvs;
            return this.pdvs.filter(pdv =>
                pdv.name_pdv.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                pdv.address_pdv.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
        selectedPdvObj() {
            return this.pdvs.find(p => p.id === this.selectedPdv) || null
        }
    },
    methods: {
        getActivePdvs() {
            axios.get('/get-active-pdvs')
                .then(({ data }) => {
                    this.pdvs = data.pdvs;
                    if(data.selected_pdv !== null){
                        this.selectedPdv = data.selected_pdv;
                    }else{
                        if (this.pdvs.length > 0) {
                            this.selectedPdv = this.pdvs[0].id;
                        }
                    }
                    EventBus.$emit('change-select-pdv', { select_pdv: this.selectedPdv });
                })
                .catch(error => {
                    console.error("Error al obtener los PDVs activos", error);
                });
        },

        changeSelectedPDV(pdvId) {
            this.loading++;

            axios.post('/change-selected-pdv', { pdv_id: pdvId })
                .then(response => {
                    EventBus.$emit('change-select-pdv', { select_pdv: this.selectedPdv });
                })
                .catch(error => {
                    console.error('Error al cambiar el PDV seleccionado:', error);
                    this.loading--;
                });
        },

        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            } else {
                this.searchQuery = "";
            }
        },
        selectPdv(pdv) {
            this.selectedPdv = pdv.id;
            this.isOpen = false;
            this.searchQuery = "";
            this.changeSelectedPDV(pdv.id);
        },
        truncateText(text, maxLength) {
            if (!text) return 'Sin Dirección'
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
        handleClickOutside(event) {
            const clickInside = this.$refs.customSelect.contains(event.target) ||
                (this.$refs.optionsList && this.$refs.optionsList.contains(event.target));
            if (!clickInside) {
                this.isOpen = false;
                this.searchQuery = "";
            }
        },
    }
};
</script>
